import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';
import 'swiper/scss';
import 'swiper/scss/autoplay';
if (customElements.get('component-header') === undefined) {
    class Header extends HTMLElement {
        constructor() {
            super();
            this.swiper = this.querySelector('.swiper');
            this.carousel = null;
            this.style.display = 'block';
            this.style.position = 'relative';
        }
        static get observedAttributes() {
            return [];
        }
        attributeChangedCallback(attr, oldVal, newVal) {
            if (oldVal !== newVal) {
                this[attr] = newVal;
            }
        }
        connectedCallback() {
            this.setCarousel();
            this.hideHeader();
            this.openMenu();
            this.redirect();
        }
        setCarousel() {
            this.carousel = new Swiper(this.swiper, {
                modules: [Autoplay],
                slidesPerView: 1,
                centeredSlides: true,
                loop: true,
                speed: 700,
                autoplay: {
                    delay: 5500,
                }
            });
        }
        hideHeader() {
            let header = document.querySelector('.header_wrapper');
            if (header != null) {
                let lastScrollTop = 0;
                window.addEventListener('scroll', function () {
                    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                    if (scrollTop > lastScrollTop) {
                        // Scroll hacia abajo
                        header.classList.add('hidden');
                    }
                    else {
                        // Scroll hacia arriba
                        header.classList.remove('hidden');
                    }
                    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // Evitar números negativos
                });
            }
        }
        openMenu() {
            const offcanvas = document.getElementById('menuMovil');
            const back = document.querySelector('.header-offcanvas-backdrop');
            document.querySelector('.open-btn').addEventListener('click', () => {
                offcanvas.classList.toggle('show');
                back.classList.toggle('show');
            });
            document.querySelector('.close-btn').addEventListener('click', () => {
                offcanvas.classList.toggle('show');
                back.classList.toggle('show');
            });
            back.addEventListener('click', () => {
                offcanvas.classList.toggle('show');
                back.classList.toggle('show');
            });
        }
        redirect() {
            if (localStorage.getItem('redirect') != null) {
                localStorage.removeItem('redirect');
                window.location = '/pages/cotizacion';
            }
        }
    }
    customElements.define('component-header', Header);
}
